import { appLogging } from "./appLogging";

export const SESSION_ID_KEY = appLogging.sessionIds.key;
export const { getSessionId } = appLogging.sessionIds;
